import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { registerApplication, start } from 'single-spa';

// Set global flag to indicate microfrontend mode for child apps
(window as any).__IS_MICROFRONTEND__ = true;

// Create and add the loader element to the DOM
const createLoader = () => {
  const loaderContainer = document.createElement('div');
  loaderContainer.id = 'mf-loader';
  loaderContainer.className = 'mf-loader-container hidden';
  loaderContainer.innerHTML = `
    <div class="mf-loader"></div>
    <span class="mf-loader-text">Loading...</span>
  `;
  document.body.appendChild(loaderContainer);
  return loaderContainer;
};

const loader = createLoader();

// Show loader when microfrontend starts loading
const showLoader = () => {
  loader.classList.remove('hidden');
};

// Hide loader when microfrontend finishes loading
const hideLoader = () => {
  loader.classList.add('hidden');
};

// Check if navigating to microfrontend root (not internal routes)
// Only show loader for initial load: /ecm, /ecm/, /spectre, /spectre/
const isMicrofrontendRoute = (path: string) => {
  return path === '/ecm' || path === '/ecm/' ||
    path === '/spectre' || path === '/spectre/';
};

// Show loader when navigating to microfrontend routes
window.addEventListener('single-spa:before-routing-event', () => {
  const path = window.location.pathname;
  if (isMicrofrontendRoute(path)) {
    showLoader();
  }
});

// Hide loader after routing completes (with small delay to ensure render)
window.addEventListener('single-spa:routing-event', () => {
  setTimeout(hideLoader, 200);
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

registerApplication({
  name: 'ecm-client',
  app: () => (window as any).System.import('ecm-client'),
  activeWhen: (location) => {
    const session = (window as any).__USER_SESSION__;
    return location.pathname.startsWith('/ecm') && session?.ecmUser === true;
  },
});

registerApplication({
  name: 'spectre-mf',
  app: () => (window as any).System.import('spectre-mf'),
  activeWhen: (location) => {
    const session = (window as any).__USER_SESSION__;
    return location.pathname.startsWith('/spectre') && session?.spectreUser === true;
  },
});

start();

reportWebVitals();
